<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md12>
				<filter-media
					v-model="filter"
					@filter="onFilter()"
				></filter-media>
			</v-flex>
			<v-flex xs12 md12 class="text-md-right">
				<input
					type="file"
					id="file"
					@change="uploadFile"
					multiple
					accept="image/*"
					class="inputfile"
					@input="form.file = $event.target.files"
				/>
				<template v-if="!form.progress">
					<label for="file">
						<v-icon dark>mdi-upload</v-icon>Uploads
					</label>
				</template>
				<template v-else>
					<half-circle-spinner
						:animation-duration="1000"
						:size="97"
						color="blue"
					/>
				</template>
			</v-flex>
			<v-flex xs12>
				<app-datatable
					:title="$t('title.media_datatable')"
					:endpoint="endpoint"
					:data="data"
					:headers="headers"
					:filter="filter"
					@onEdit="editItem"
					@onDelete="deleteItem"
					@onView="viewItem"
					:hasMediaUpload="true"
					@OnuploadFile="uploadFile"
				>
					<template v-slot:[`item.image`]="{ item }">
						<v-img :src="item.url" width="100" height="75"> </v-img>
					</template>
					<template v-slot:[`item.action`]="{ item }">
						<v-btn color="success" text x-small outlined fab>
							<v-icon small @click="editItem(item)">
								mdi-pencil
							</v-icon>
						</v-btn>
						<v-btn
							color="error"
							text
							x-small
							outlined
							fab
							@click="deleteItem(item)"
						>
							<v-icon>mdi-trash-can-outline</v-icon>
						</v-btn>
					</template>
				</app-datatable>
			</v-flex>
		</v-layout>

		<v-dialog v-model="dialog" persistent max-width="700px" scrollable>
			<v-form>
				<v-card>
					<v-card-title primary-title>
						{{ $t("title.media_library") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12 md12>
								<v-text-field
									v-model="item.filename"
									:label="$t('Name')"
									filled
								></v-text-field>
							</v-flex>
						</v-layout>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="info" text @click="closeItem()"
							><v-icon left>mdi-arrow-left</v-icon
							>{{ $t("label.cancel") }}</v-btn
						>
						<v-btn color="primary" @click.native="submit()">
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Save") }}</v-btn
						>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<app-delete-id-dialog
			ref="deleteDialog"
			:endpoint="'central.media.destroy'"
			:id="item.id"
		></app-delete-id-dialog>
	</v-container>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";
import pickBy from "lodash/pickBy";
export default {
	props: {
		data: Object,
	},
	components: {
		HalfCircleSpinner,
	},
	data() {
		return {
			item: {},
			filter: {},
			dialog: false,
			loading: false,
			form: this.$inertia.form({
				file: [],
			}),
		};
	},
	computed: {
		endpoint() {
			return this.$route("central.media.index");
		},
		headers() {
			return [
				{
					text: this.$t("Image"),
					value: "image",
					align: "start",
					sortable: false,
				},
				{
					text: this.$t("Name"),
					value: "filename",
					sortable: false,
					searchable: false,
				},

				{
					text: this.$t("label.size"),
					value: "size",
					sortable: false,
					searchable: false,
				},

				{
					text: this.$t("Action"),
					value: "action",
					sortable: false,
					searchable: false,
					align: "left",
					width: 120,
				},
			];
		},
	},

	methods: {
		onFilter() {
			var filter = pickBy(this.filter);
			this.$inertia.get(
				this.endpoint,
				{ filter },
				{
					preserveState: true,
					preserveScroll: true,
				}
			);
		},
		close() {
			this.dialog = false;
		},
		submit() {
			this.$inertia.put(
				this.$route("central.media.update", this.item.id),
				this.item,
				{
					onFinish: () => this.close(),
				}
			);
		},

		editItem(item) {
			this.item = Object.assign({}, item);
			this.dialog = true;
		},
		closeItem() {
			this.item = Object.assign({}, {});
			this.dialog = false;
		},
		viewItem() {
			//
		},

		deleteItem(item) {
			this.item = Object.assign({}, item);
			this.$refs.deleteDialog.open();
		},
		async uploadFile(e) {
			this.form.post(this.$route("central.media.store"), {
				forceFormData: true,
			});
		},
	},
};
</script>

<style  scoped>
input[type="file"] {
	display: none;
}
.inputfile + label {
	cursor: pointer; /* "hand" cursor */
}
.inputfile {
	top: 20px;
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
	float: right;
}
.inputfile + label {
	font-size: 1.25em;
	font-weight: 700;
	padding: 10px 10px;
	color: white;
	background-color: blue;
	display: inline-block;
}

.inputfile:focus + label,
.inputfile + label:hover {
	background-color: red;
}
</style>